const zhHome = {
  hero: {
    badge: '🔥 每日更新',
    title: '发现最受欢迎的',
    titleHighlight: '韩国漫画',
    subtitle: '海量韩漫在线免费阅读，每日更新热门连载与经典完结作品',
    cta: '开始阅读',
    browse: '浏览分类',
  },
  featured: {
    label: '精选合集',
    title: '编辑力荐',
    hotSeries: {
      title: '热门连载',
      desc: '追更不停，精彩不断',
      tags: ['恋爱', '奇幻', '动作', '悬疑'],
    },
    newArrival: {
      title: '新作上架',
      desc: '第一时间发现好作品',
      badge: 'NEW',
    },
    completed: {
      title: '经典完结',
      desc: '一口气读完的快乐',
      count: '200+ 部完结作品',
    },
  },
  hotWorks: {
    title: '热门韩漫',
    subtitle: '千万读者的共同选择，口碑与热度齐飞',
    readBtn: '立即阅读',
    subscribeBtn: '订阅追更',
    updateLabel: '每周一、四更新',
  },
  reviews: {
    title: '漫友口碑',
    subtitle: '来自真实读者的评价',
    review1: {
      text: '画风真的太绝了！每一帧都像壁纸一样精美，剧情也环环相扣，追更根本停不下来。这个平台更新速度也很快，强烈推荐！',
      author: '星辰大海',
      role: 'VIP 读者',
    },
    review2: {
      text: '一直在找能稳定看韩漫的地方，终于找到了！资源很全，分类清晰，阅读体验也很流畅，已经推荐给身边所有喜欢漫画的朋友了。',
      author: '二次元少年',
      role: '资深漫友',
    },
    review3: {
      text: '从学生时代就开始看韩漫，这个网站是我用过最好的。不仅有热门连载，还有很多经典老作品可以回味，真心好评！',
      author: '漫画老司机',
      role: '十年漫龄',
    },
    cta: '查看更多评价',
  },
  cta: {
    title: '准备好了吗？',
    titleHighlight: '开启你的韩漫之旅',
    subtitle: '数千部精品韩漫等你来发现，现在就加入我们',
    btn: '免费开始阅读',
  },
};

export default zhHome;